module.exports = __webpack_public_path__ + "img/resto bar.d9d48a46.jpeg";